import thunk from 'redux-thunk';

export default [thunk];



// WEBPACK FOOTER //
// ./src/store/middleware/index.js